import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiPlus,
  FiEdit,
  FiEye,
  FiCheckCircle,
  FiXCircle,
  FiTag,
  FiDollarSign,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function PlansPricing() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [plans] = useState([
    {
      id: 1,
      planName: "Basic Plan",
      price: 999,
      duration: "Monthly",
      features: ["Market Calls", "Basic Reports"],
      status: "Active",
      subscribers: 45,
      createdAt: "2024-01-01",
    },
    {
      id: 2,
      planName: "Premium Plan",
      price: 2499,
      duration: "Monthly",
      features: ["Market Calls", "Premium Reports", "1-on-1 Consultation"],
      status: "Active",
      subscribers: 23,
      createdAt: "2024-01-01",
    },
    {
      id: 3,
      planName: "Annual Basic",
      price: 9999,
      duration: "Annual",
      features: ["Market Calls", "Basic Reports"],
      status: "Active",
      subscribers: 12,
      createdAt: "2024-01-01",
    },
  ]);

  const handleCreatePlan = () => {
    Swal.fire({
      title: "Create New Plan",
      html: `
        <input id="planName" class="swal2-input" placeholder="Plan Name" required>
        <input id="price" class="swal2-input" type="number" placeholder="Price (₹)" required>
        <select id="duration" class="swal2-select">
          <option value="Monthly">Monthly</option>
          <option value="Annual">Annual</option>
        </select>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Create Plan",
      confirmButtonColor: "#006e82",
    });
  };

  const handleEditPlan = (planId) => {
    Swal.fire({
      title: "Edit Plan",
      html: `
        <input id="planName" class="swal2-input" placeholder="Plan Name" value="Basic Plan">
        <input id="price" class="swal2-input" type="number" placeholder="Price (₹)" value="999">
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Save Changes",
      confirmButtonColor: "#006e82",
    });
  };

  const handleToggleStatus = (planId, currentStatus) => {
    Swal.fire({
      title: `${currentStatus === "Active" ? "Deactivate" : "Activate"} Plan?`,
      text: `This plan will be ${currentStatus === "Active" ? "deactivated" : "activated"}.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Yes, ${currentStatus === "Active" ? "Deactivate" : "Activate"}`,
      confirmButtonColor: currentStatus === "Active" ? "#ef4444" : "#10b981",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Updated!", `Plan has been ${currentStatus === "Active" ? "deactivated" : "activated"}.`, "success");
      }
    });
  };

  const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const filteredPlans = plans.filter((plan) => {
    const matchesSearch =
      plan.planName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || plan.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredPlans.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredPlans.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="content-page-header content-page-headersplit">
                <h5>Plans & Pricing</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/research/plans-pricing">Research</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Plans & Pricing
                  </li>
                </ol>
              </nav>

          
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */} 
                <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-6">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by plan name..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                <button className="btn btn-primary" onClick={handleCreatePlan}>
                  Create Plan
                </button>
              </div>
              </div>
            </div>

            {/* Plans Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Plan Name</th>
                          <th>Price</th>
                          <th>Duration</th>
                          <th>Features</th>
                          <th>Subscribers</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="7">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((plan) => (
                            <tr key={plan.id}>
                              <td style={{ fontWeight: "500" }}>{plan.planName}</td>
                              <td style={{ fontWeight: "600" }}>{formatINR(plan.price)}</td>
                              <td>{plan.duration}</td>
                              <td>
                                <div className="d-flex flex-column gap-1">
                                  {plan.features.map((feature, idx) => (
                                    <span key={idx} className="badge" style={{
                                      background: "#f0f9ff",
                                      color: "#006e82",
                                      padding: "4px 8px",
                                      borderRadius: "4px",
                                      fontSize: "11px",
                                      width: "fit-content",
                                    }}>
                                      {feature}
                                    </span>
                                  ))}
                                </div>
                              </td>
                              <td style={{ fontWeight: "600" }}>{plan.subscribers}</td>
                              <td>
                                <span className={plan.status === "Active" ? "badge-active" : "badge-pending"}>
                                  {plan.status}
                                </span>
                              </td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleEditPlan(plan.id)}
                                    title="Edit Plan"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </div>
                                  <div
                                    className="delete-table"
                                    onClick={() => handleToggleStatus(plan.id, plan.status)}
                                    title={plan.status === "Active" ? "Deactivate" : "Activate"}
                                    style={{ cursor: "pointer", color: plan.status === "Active" ? "#ef4444" : "#10b981" }}
                                  >
                                    {plan.status === "Active" ? (
                                      <i className="fas fa-times-circle"></i>
                                    ) : (
                                      <i className="fas fa-check-circle"></i>
                                    )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
